var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo_exhibition"},[_c('div',{staticClass:"text"},[_c('div',{staticClass:"box"},[(_vm.pic)?_c('img',{attrs:{"src":_vm.pic,"alt":""}}):_c('div',[_vm._v("图片消失啦！~ ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }